import { Text } from "@mantine/core";
import React from "react";
import styles from "./Section2.module.scss";
import { useNavigate } from "react-router-dom";
import { getCookiesSession } from "../../../cookiesSession";
import constants from "../../../utilities/constants";
import { Tooltip } from "@mantine/core";

const activeModules = [
  {
    id: 1,
    name: "Contracts Studio",
    val: "agreement",
    icon: "https://cdn1.iconfinder.com/data/icons/digital-banking-vol-1/80/contract__partnership__agreement__handshake_-512.png",
    url: "/app/agreements_manager/",
  },
  {
    id: 2,
    name: "Obligations Hub",
    val: "obligation",
    icon: "https://img.icons8.com/ios/512/todo-list.png",
    url: constants.obligationsUrl,
  },
  {
    id: 3,
    name: "Receivables Engine",
    val: "recovery",
    icon: "https://cdn-icons-png.flaticon.com/512/3535/3535035.png",
    url: constants.recoveryUrl,
  },
];

function Section2() {
  const navigate = useNavigate();
  const AppConfig = window.AppConfig;

  const userDataRaw = getCookiesSession("masterResult");
  if (!userDataRaw) {
    navigate("/login");
    return null;
  }

  const handleClick = (url, isEnabled) => {
    // Only open the link if the config is true
    if (isEnabled) {
      window.open(url, "_blank");
    }
  };

  return (
    <div>
      <div className="hero-section">
        <h1 className="hero-title">
          Contracts Simplified | Growth Amplified | Trust Fortified
        </h1>
      </div>
      <div className="modules-grid">
        {activeModules.map((module) => {
          const isEnabled = AppConfig?.modules?.[module.val] === true;

          return (
            <Tooltip
              key={module.id}
              label="This module is not enabled for your account"
              disabled={isEnabled}
              position="bottom"
              color="red"
              style={{ fontSize: "16px", textTransform: "none" }}
            >
              <div
                className="module-item"
                style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
              >
                <button
                  className={styles.moduleButton}
                  disabled={!isEnabled}
                  onClick={() => handleClick(module.url, isEnabled)}
                >
                  <div className={styles.moduleCard}>
                    <div
                      className={`${styles.imgContainer} ${
                        !isEnabled ? styles.disabledCard : ""
                      }`}
                    >
                      <img
                        className={styles.img}
                        src={module.icon}
                        alt={module.name}
                        style={{ filter: "invert(1)" }}
                      />
                    </div>

                    <Text className={styles.moduleName}>{module.name}</Text>
                  </div>
                </button>
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}

export default Section2;
